import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    isOpen: false,
    mode: null,
    callerUid: null,
    roomId: null,
    callInfo: null
};
export const callsSlice = createSlice({
    name: 'calls',
    initialState,
    reducers: {
        openModalCalls(state, action) {
            state.isOpen = true;
            state.callerUid = action.payload.callerUid;
            state.mode = action.payload.mode;
            state.roomId = action.payload.roomId;
            state.callInfo = action.payload.callInfo;
        },
        closeModalCalls(state, action) {
            if (action.payload && state.mode)
                return;
            state.isOpen = false;
            state.callerUid = null;
            state.mode = null;
            state.roomId = null;
            state.callInfo = null;
        },
        setStatusMod(state, action) {
            state.mode = action.payload;
        }
    }
});
export const { openModalCalls, closeModalCalls, setStatusMod } = callsSlice.actions;
export default callsSlice.reducer;
